<template>
  <div>
    <div class="d-inline-flex">
      <luci-btn-icon :config="addLanguageBtnConfig" @callback="$router.push({ name: 'LanguageCreate' })"></luci-btn-icon>
      <luci-btn-icon :config="refreshTableBtnConfig" @callback="getItems({ sortBy })"></luci-btn-icon>
    </div>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <luci-table :loading="isLoading || deleteLoading" :config="languageTableConfig" @edit-row-callback="editLanguage" @delete-row-callback="openDeleteModal" @sort-by-callback="sortCallback"></luci-table>
    <paging name="language-list" :view="view" @page="gotoPage"></paging>

    <confirm-modal
      :item="itemForModal"
      :open="showDeleteModal"
      :message="modalMessage"
      @yes-callback="deleteLanguage"
      @no-callback="closeDeleteModal"
    ></confirm-modal>

    <message-modal :open="showMsgModal" @ok-callback="showMsgModal = false"></message-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { split } from 'lodash'

import ConfirmModal from '../modal/ConfirmModal'
import MessageModal from '../modal/MessageModal'
import Paging from '../shared/paging/Paging'
import variables from '../../helpers/variables'

export default {
  components: {
    ConfirmModal, MessageModal, Paging
  },
  data () {
    return {
      showMsgModal: false,
      itemForModal: null,
      modalTitle: '',
      modalMessage: '',
      showDeleteModal: false,
      addLanguageBtnConfig: {
        type: 'button',
        name: 'add-language-btn',
        primary: true,
        icon: true,
        iconType: 'add',
        toolTip: 'Add a new language'
      },
      refreshTableBtnConfig: variables.refreshBtnIconOptions,
      sortBy: null
    }
  },
  computed: {
    ...mapGetters({
      deletedItem: 'language/del/deleted',
      error: 'language/list/error',
      items: 'language/list/items',
      isLoading: 'language/list/isLoading',
      view: 'language/list/view',
      tableItems: 'language/list/tableItems',
      deleteError: 'language/del/error',
      deleteLoading: 'language/del/isLoading'
    }),
    languageTableConfig () {
      return {
        title: 'Languages',
        showSearch: true,
        items: this.tableItems,
        headers: [
          { text: 'Name', value: 'data.name', sortable: true },
          { text: 'Code', value: 'data.code', sortable: true },
          { text: 'Actions', value: 'actions' }
        ],
        pagination: { sortBy: 'data.name' },
        serverSorting: true,
        hideActions: true,
        showButtonEdit: true,
        showButtonDelete: true
      }
    }
  },
  created () {
    this.getItems({ sortBy: this.sortBy })
  },
  methods: {
    ...mapActions({
      getItems: 'language/list/getItems',
      deleteItem: 'language/del/del'
    }),
    editLanguage (item) {
      this.$router.push({ name: 'LanguageUpdate', params: { id: item['@id'] } })
    },
    openDeleteModal (item) {
      this.itemForModal = item
      this.modalTitle = 'Delete language?'
      this.modalMessage = `Do you want to delete language: <b>${item.name}</b>?`
      this.showDeleteModal = true
    },
    deleteLanguage (item) {
      this.showDeleteModal = false
      this.deleteItem(item).then(() => {
        if (!this.deleteError) {
          this.itemForModal = null
          this.modalTitle = ''
          this.modalMessage = ''
          this.getItems({ sortBy: this.sortBy })
        } else {
          this.showMsgModal = true
        }
      })
    },
    closeDeleteModal () {
      this.showDeleteModal = false
      this.itemForModal = null
      this.modalTitle = ''
      this.modalMessage = ''
    },
    gotoPage (page) {
      this.getItems({ sortBy: this.sortBy, page: this.view['hydra:' + page] })
    },
    sortCallback (column, descending) {
      const field = split(column, '.')[1]
      const direction = descending ? 'desc' : 'asc'
      this.sortBy = `order[${field}]=${direction}`
      this.getItems({ sortBy: this.sortBy })
    }
  }
}
</script>
